export enum ArchiveOrderField {
  WBS_SN = 'WBS_SN',
  MATERIAL_BATCH = 'MATERIAL_BATCH',
  SUBMIT_DATE = 'SUBMIT_DATE',
  FINISH_DATE = 'FINISH_DATE',
  FORM_DIR = 'FORM_DIR',
  FORM_CODE = 'FORM_CODE',
  FORM_SN = 'FORM_SN',
}

export const ArchiveOrderFieldMap = {
  [ArchiveOrderField.WBS_SN]: 'WBS编号',
  [ArchiveOrderField.MATERIAL_BATCH]: '材料批次',
  [ArchiveOrderField.SUBMIT_DATE]: '提交日期',
  [ArchiveOrderField.FINISH_DATE]: '完成日期',
  [ArchiveOrderField.FORM_CODE]: '表单代号',
  [ArchiveOrderField.FORM_DIR]: '表单目录',
  [ArchiveOrderField.FORM_SN]: '表单编号',
};

export const ArchiveOrderFieldOptions = [
  {
    label: ArchiveOrderFieldMap[ArchiveOrderField.WBS_SN],
    value: ArchiveOrderField.WBS_SN,
  },
  {
    label: ArchiveOrderFieldMap[ArchiveOrderField.SUBMIT_DATE],
    value: ArchiveOrderField.SUBMIT_DATE,
  },
  {
    label: ArchiveOrderFieldMap[ArchiveOrderField.FINISH_DATE],
    value: ArchiveOrderField.FINISH_DATE,
  },
  {
    label: ArchiveOrderFieldMap[ArchiveOrderField.FORM_DIR],
    value: ArchiveOrderField.FORM_DIR,
  },
  {
    label: ArchiveOrderFieldMap[ArchiveOrderField.FORM_CODE],
    value: ArchiveOrderField.FORM_CODE,
  },
  {
    label: ArchiveOrderFieldMap[ArchiveOrderField.FORM_SN],
    value: ArchiveOrderField.FORM_SN,
  },
];

export const ArchiveWBSOrderFieldOptions = [
  {
    label: ArchiveOrderFieldMap[ArchiveOrderField.WBS_SN],
    value: ArchiveOrderField.WBS_SN,
  },
  {
    label: ArchiveOrderFieldMap[ArchiveOrderField.FORM_DIR],
    value: ArchiveOrderField.FORM_DIR,
  },
  {
    label: ArchiveOrderFieldMap[ArchiveOrderField.SUBMIT_DATE],
    value: ArchiveOrderField.SUBMIT_DATE,
  },
  {
    label: ArchiveOrderFieldMap[ArchiveOrderField.FINISH_DATE],
    value: ArchiveOrderField.FINISH_DATE,
  },
];

export const ArchiveMaterialOrderFieldOptions = [
  {
    label: ArchiveOrderFieldMap[ArchiveOrderField.FORM_SN],
    value: ArchiveOrderField.FORM_SN,
  },
  {
    label: ArchiveOrderFieldMap[ArchiveOrderField.MATERIAL_BATCH],
    value: ArchiveOrderField.MATERIAL_BATCH,
  },
  {
    label: ArchiveOrderFieldMap[ArchiveOrderField.SUBMIT_DATE],
    value: ArchiveOrderField.SUBMIT_DATE,
  },
  {
    label: ArchiveOrderFieldMap[ArchiveOrderField.FINISH_DATE],
    value: ArchiveOrderField.FINISH_DATE,
  },
];

export const ArchiveRegularOrderFieldOptions = [
  {
    label: ArchiveOrderFieldMap[ArchiveOrderField.FORM_SN],
    value: ArchiveOrderField.FORM_SN,
  },
  {
    label: ArchiveOrderFieldMap[ArchiveOrderField.FORM_CODE],
    value: ArchiveOrderField.FORM_CODE,
  },
  {
    label: ArchiveOrderFieldMap[ArchiveOrderField.SUBMIT_DATE],
    value: ArchiveOrderField.SUBMIT_DATE,
  },
  {
    label: ArchiveOrderFieldMap[ArchiveOrderField.FINISH_DATE],
    value: ArchiveOrderField.FINISH_DATE,
  },
];
